export default {
  PRE_AUTH: 10,
};
